import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { SharedValidatorsModule } from '../../shared/validators/shared-validators.module';
import { DuplicateCustomerModalComponent } from './add-customer-duplicate-modal.component';
import { AddCustomerComponent } from './add-customer.component';
import { CustomerDetailsModalModule } from '../detail/customer-detail-modal/customer-details-modal.module';

@NgModule({
    declarations: [
        AddCustomerComponent,
        DuplicateCustomerModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        CustomerDetailsModalModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        InputMaskModule,
        MVMSpinnerBtnModule,
        RadioButtonModule,
        ReactiveFormsModule,
        SharedPipesModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule,
        RouterModule
    ],
    exports: [
        AddCustomerComponent,
        DuplicateCustomerModalComponent
    ]
})

export class AddCustomerModule {
}
